import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeatureMapListStyles {
  root?: IStyle;
  subTitle?: IStyle;
  list?: IStyle;
}

export interface IEditFeatureMapListClassNames {
  root: string;
  subTitle: string;
  list: string;
}

export const editFeatureMapListStylesDefault = (_theme: IH2OTheme): Partial<IEditFeatureMapListStyles> => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '150px',
  },
  subTitle: {
    textAlign: 'right',
    marginBottom: '8px',
  },
  list: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
});
